export const MONTE = 'Monte';
export const DEMONTE = 'Demonte';
export const AMONTE = 'AMonter';
export const ADEMONTE = 'ADemonter';
export const ENCOURSMONTAGE = 'EnCoursMontage';
export const ENCOURSDEMONTAGE = 'EnCoursDemontage';
export const ENCOURSDEFABRICATION = 'EnCoursDeFabrication';
export const FABRIQUE = 'Fabrique';

export const ETAT_DISPOSITIF_PUBLICITAIRE = [
  { libelle: 'face.etatListe.aDemonte', value: ADEMONTE },
  { libelle: 'face.etatListe.aMonter', value: AMONTE },
  { libelle: 'face.etatListe.demonte', value: DEMONTE },
  { libelle: 'face.etatListe.monte', value: MONTE },
  { libelle: 'face.etatListe.enCoursMontage', value: ENCOURSMONTAGE },
  { libelle: 'face.etatListe.enCoursDemontage', value: ENCOURSDEMONTAGE },
];

export const ETAT_DISPOSITIF_PUBLICITAIRE_DEMONTE = [
  { libelle: 'face.etatListe.demonte', value: DEMONTE },
];

export const ETAT_DISPOSITIF_PUBLICITAIRE_MODULE_EMPLACEMENT = [
  { libelle: 'face.etatListe.enCoursDeFabrication', value: ENCOURSDEFABRICATION },
  { libelle: 'face.etatListe.fabrique', value: FABRIQUE },
];

export const ALL_ETAT_DISPOSITIF_PUBLICITAIRE = [
  { libelle: 'face.etatListe.aDemonte', value: ADEMONTE },
  { libelle: 'face.etatListe.aMonter', value: AMONTE },
  { libelle: 'face.etatListe.demonte', value: DEMONTE },
  { libelle: 'face.etatListe.monte', value: MONTE },
  { libelle: 'face.etatListe.enCoursMontage', value: ENCOURSMONTAGE },
  { libelle: 'face.etatListe.enCoursDemontage', value: ENCOURSDEMONTAGE },
  { libelle: 'face.etatListe.enCoursDeFabrication', value: ENCOURSDEFABRICATION },
  { libelle: 'face.etatListe.fabrique', value: FABRIQUE },
];
